import { NewPaginationModel } from 'types';
import { PoinzApiClient } from '../../api';

const apiRoot = `/search/business-profiles`;

const getBusinessProfiles =
  (apiClient: PoinzApiClient) =>
  async (params?: { query: string }): Promise<NewPaginationModel<{ id: number; name: string }>> => {
    const initialParams = {
      query: '',
      size: 1000
    };
    const res = await apiClient.get(apiRoot, { queryParams: { ...initialParams, ...params } });
    return res.body;
  };

export default (apiClient: PoinzApiClient) => ({
  getBusinessProfiles: getBusinessProfiles(apiClient)
});
